import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { BrandActions } from "../actions";
import { BrandSelectors } from "../selectors";

@Injectable()
export class BrandFacade {
  brandList$ = this.store.pipe(select(BrandSelectors.brandGetList));
  isLoading$ = this.store.pipe(select(BrandSelectors.isLoading));

  constructor(private readonly store: Store) {}

  brandGetList() {
    return this.store.dispatch(BrandActions.brandGetList());
  }
}
